import { useAppSelector } from '@hooks/app/redux';
import { memberApiV2 } from '@lib/api';
import { AsyncSelect, AsyncSelectProps } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';
import { OptionTypeBase } from 'react-select';

interface EmployeesSelectProps
  extends Omit<
    AsyncSelectProps<OptionTypeBase, false>,
    'loadOptions' | 'placeholder' | 'isMulti' | 'cacheOptions' | 'defaultOptions'
  > {
  notInWorkspaceId?: string;
}

const EmployeesSelect: React.FunctionComponent<EmployeesSelectProps> = ({
  notInWorkspaceId,
  ...rest
}) => {
  const { formatMessage } = useIntl();
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  const institutionOpts = React.useCallback(
    async (query: string) => {
      const staff = (
        await memberApiV2.searchStaff(providerId as string, {
          page: 1,
          pageSize: 30,
          sortBy: 'lastName',
          direction: 'ASC',
          name: query,
          statuses: ['approved'],
          notInWorkspaceId,
        })
      ).data;

      return staff.data.items.map((e: any) => ({
        value: e.user.id,
        label: `${e.user.firstName} ${e.user.lastName}`,
      }));
    },
    [providerId, notInWorkspaceId],
  );

  return (
    <AsyncSelect
      loadOptions={institutionOpts}
      isMulti={false}
      cacheOptions
      defaultOptions
      placeholder={formatMessage({ id: 'rs_placeholder' })}
      {...rest}
    />
  );
};

export default EmployeesSelect;
